"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOutcodesInAreaAreasOutcodesGetRequest$ = exports.GetOutcodesInAreaAreasOutcodesGetRequest$outboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetRequest$inboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetSecurity$ = exports.GetOutcodesInAreaAreasOutcodesGetSecurity$outboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetSecurity$inboundSchema = void 0;
exports.getOutcodesInAreaAreasOutcodesGetSecurityToJSON = getOutcodesInAreaAreasOutcodesGetSecurityToJSON;
exports.getOutcodesInAreaAreasOutcodesGetSecurityFromJSON = getOutcodesInAreaAreasOutcodesGetSecurityFromJSON;
exports.getOutcodesInAreaAreasOutcodesGetRequestToJSON = getOutcodesInAreaAreasOutcodesGetRequestToJSON;
exports.getOutcodesInAreaAreasOutcodesGetRequestFromJSON = getOutcodesInAreaAreasOutcodesGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetOutcodesInAreaAreasOutcodesGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetOutcodesInAreaAreasOutcodesGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodesInAreaAreasOutcodesGetSecurity$;
(function (GetOutcodesInAreaAreasOutcodesGetSecurity$) {
    /** @deprecated use `GetOutcodesInAreaAreasOutcodesGetSecurity$inboundSchema` instead. */
    GetOutcodesInAreaAreasOutcodesGetSecurity$.inboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetSecurity$inboundSchema;
    /** @deprecated use `GetOutcodesInAreaAreasOutcodesGetSecurity$outboundSchema` instead. */
    GetOutcodesInAreaAreasOutcodesGetSecurity$.outboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetSecurity$outboundSchema;
})(GetOutcodesInAreaAreasOutcodesGetSecurity$ || (exports.GetOutcodesInAreaAreasOutcodesGetSecurity$ = GetOutcodesInAreaAreasOutcodesGetSecurity$ = {}));
function getOutcodesInAreaAreasOutcodesGetSecurityToJSON(getOutcodesInAreaAreasOutcodesGetSecurity) {
    return JSON.stringify(exports.GetOutcodesInAreaAreasOutcodesGetSecurity$outboundSchema.parse(getOutcodesInAreaAreasOutcodesGetSecurity));
}
function getOutcodesInAreaAreasOutcodesGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodesInAreaAreasOutcodesGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetOutcodesInAreaAreasOutcodesGetSecurity' from JSON`);
}
/** @internal */
exports.GetOutcodesInAreaAreasOutcodesGetRequest$inboundSchema = z.object({
    point: z.array(z.string()),
    radius: z.number().int().optional(),
});
/** @internal */
exports.GetOutcodesInAreaAreasOutcodesGetRequest$outboundSchema = z.object({
    point: z.array(z.string()),
    radius: z.number().int().optional(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodesInAreaAreasOutcodesGetRequest$;
(function (GetOutcodesInAreaAreasOutcodesGetRequest$) {
    /** @deprecated use `GetOutcodesInAreaAreasOutcodesGetRequest$inboundSchema` instead. */
    GetOutcodesInAreaAreasOutcodesGetRequest$.inboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetRequest$inboundSchema;
    /** @deprecated use `GetOutcodesInAreaAreasOutcodesGetRequest$outboundSchema` instead. */
    GetOutcodesInAreaAreasOutcodesGetRequest$.outboundSchema = exports.GetOutcodesInAreaAreasOutcodesGetRequest$outboundSchema;
})(GetOutcodesInAreaAreasOutcodesGetRequest$ || (exports.GetOutcodesInAreaAreasOutcodesGetRequest$ = GetOutcodesInAreaAreasOutcodesGetRequest$ = {}));
function getOutcodesInAreaAreasOutcodesGetRequestToJSON(getOutcodesInAreaAreasOutcodesGetRequest) {
    return JSON.stringify(exports.GetOutcodesInAreaAreasOutcodesGetRequest$outboundSchema.parse(getOutcodesInAreaAreasOutcodesGetRequest));
}
function getOutcodesInAreaAreasOutcodesGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodesInAreaAreasOutcodesGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetOutcodesInAreaAreasOutcodesGetRequest' from JSON`);
}
//# sourceMappingURL=getoutcodesinareaareasoutcodesget.js.map